/* eslint-disable no-param-reassign */
import { takeLatest, put } from 'redux-saga/effects';
import * as types from './types';
import { changeBackgroundLabel } from '../../fabric_obj/label';

export function* editPagesSettingsSaga() {
  yield takeLatest(types.EDIT_PAGE_SETTINGS, function* ({ payload }) {
    try {
      changeBackgroundLabel('', payload.color);
      yield put({ type: types.CHANGE_PAGE_SETTING, payload: payload });
    } catch (error) {
      console.log('edit pages settings error');
    }
  });
}
